





































































































































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { maskMoney, maskDate as formatarData } from '@/utils/common'
import AntecipacaoRecebiveisStore from '../RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'

@Component({ name: 'HistoricoAntecipacoes' })
export default class HistoricoAntecipacoes extends Vue {
  filtroDataInicio: string = ''
  filtroDataFim: string = ''
  filtroStatus: number | null = null
  filtroHospital: string | null = null

  descricaoMovimentacao: string = 'Antecipação de recebíveis'

  expandidos: { [key: string]: boolean } = {}

  headerHistorico = [
    { text: '', value: '_expand', align: 'center', sortable: false, width: '48px' },
    { text: 'Data', value: 'dataSolicitacao', align: 'left', sortable: false },
    { text: 'Hospital', value: 'fontePagadoraNome', align: 'left', sortable: false },
    { text: 'Descrição', value: 'descricao', align: 'left', sortable: false },
    { text: 'Valor', value: 'totalSolicitado', align: 'right', sortable: false },
    { text: 'Status', value: 'status', align: 'center', sortable: false },
  ]

  get getAntecipacaoStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  maskMoney(value: any) {
    return maskMoney(value)
  }

  maskDate(value: any) {
    return formatarData(value)
  }

  get filtrosHistorico() {
    return {
      dataInicio: this.filtroDataInicio || null,
      dataFim: this.filtroDataFim || null,
      status: this.filtroStatus !== null && this.filtroStatus !== undefined ? this.filtroStatus : null,
      hospital: this.filtroHospital || null,
    }
  }

  get situacoesAntecipacao(): any[] {
    return this.getAntecipacaoStore.situacoes || []
  }

  get statusOptions(): Array<{ text: string, value: number | null }> {
    const historicoStatus = new Set<string>(['Solicitado', 'Aprovado', 'Reprovado'])
    const opcoes = this.situacoesAntecipacao
      .filter((s: any) => s && historicoStatus.has(String(s.nome)))
      .map((s: any) => ({ text: String(s.nome), value: Number(s.id) }))
    return [{ text: 'Todos', value: null }, ...opcoes]
  }

  get fontesPagadorasGestor(): any[] {
    return this.getAntecipacaoStore.fontesPagadorasAntecipacao || []
  }

  get hospitalOptions(): Array<{ text: string, value: string | null }> {
    const opcoes = this.fontesPagadorasGestor
      .filter((fp: any) => fp && fp.fontePagadoraNome)
      .map((fp: any) => ({ text: String(fp.fontePagadoraNome), value: String(fp.fontePagadoraNome) }))
    return [{ text: 'Todos', value: null }, ...opcoes]
  }

  get historicoItens(): any[] {
    return this.getAntecipacaoStore.historicoAntecipacao || []
  }

  get totalAntecipadoExibido(): number {
    const totalBackend = this.getAntecipacaoStore.totalAntecipado
    if (totalBackend !== null && totalBackend !== undefined) return totalBackend
    return this.historicoItens.reduce((acc: number, h: any) => acc + (Number(h.totalSolicitado) || 0), 0)
  }

  get historicoTotalPaginas(): number {
    return this.getAntecipacaoStore.historicoTotalPaginas || 1
  }

  get historicoTotalRegistros(): number {
    return this.getAntecipacaoStore.historicoTotalRegistros || 0
  }

  get historicoQtdPorPagina(): number {
    return this.getAntecipacaoStore.historicoQtdPorPagina || 25
  }

  get historicoPaginaModel(): number {
    return this.getAntecipacaoStore.historicoPagina
  }

  set historicoPaginaModel(value: number) {
    this.getAntecipacaoStore.setHistoricoPagina(value)
    this.getAntecipacaoStore.getHistoricoAntecipacao(this.filtrosHistorico)
  }

  get historicoFaixaInicio(): number {
    if (this.historicoTotalRegistros === 0) return 0
    return (this.historicoPaginaModel - 1) * this.historicoQtdPorPagina + 1
  }

  get historicoFaixaFim(): number {
    return Math.min(this.historicoPaginaModel * this.historicoQtdPorPagina, this.historicoTotalRegistros)
  }

  get paginasVisiveis(): number[] {
    const total = this.historicoTotalPaginas
    const atual = this.historicoPaginaModel
    const janela = 5
    let inicio = Math.max(1, atual - Math.floor(janela / 2))
    const fim = Math.min(total, inicio + janela - 1)
    inicio = Math.max(1, fim - janela + 1)
    const paginas: number[] = []
    for (let p = inicio; p <= fim; p += 1) paginas.push(p)
    return paginas
  }

  irParaPagina(p: number) {
    if (p < 1 || p > this.historicoTotalPaginas || p === this.historicoPaginaModel) return
    this.historicoPaginaModel = p
  }

  hospitalIniciais(nome: any): string {
    const partes = String(nome || '').trim().split(/\s+/).filter(Boolean)
    if (partes.length === 0) return '--'
    if (partes.length === 1) return partes[0].substr(0, 2).toUpperCase()
    return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase()
  }

  estaExpandido(item: any): boolean {
    return !!(item && this.expandidos[item.antecipacaoId])
  }

  toggleExpandir(item: any) {
    if (!item) return
    this.$set(this.expandidos, item.antecipacaoId, !this.expandidos[item.antecipacaoId])
  }

  movimentacoesVisiveis(item: any): any[] {
    if (!this.estaExpandido(item)) return []
    return (item && item.movimentacoes) || []
  }

  statusColor(status: any): string {
    const s = String(status || '').toLowerCase()
    if (s.indexOf('liquidado total') !== -1) return '#2E7D32'
    if (s.indexOf('liquidado parcial') !== -1) return '#EF6C00'
    if (s.indexOf('programado') !== -1) return '#6B7A99'
    if (s.indexOf('cancelad') !== -1) return '#C62828'
    if (s.indexOf('antecipad') !== -1) return '#1565C0'
    if (s.indexOf('processament') !== -1) return '#F9A825'
    if (s.indexOf('aprov') !== -1) return '#2E7D32'
    if (s.indexOf('reprov') !== -1) return '#C62828'
    if (s.indexOf('solicit') !== -1) return '#F9A825'
    if (s.indexOf('negocia') !== -1) return '#1565C0'
    if (s.indexOf('liber') !== -1) return '#00897B'
    return '#6B7A99'
  }

  async carregar() {
    this.getAntecipacaoStore.setHistoricoPagina(1)
    await Promise.all([
      this.getAntecipacaoStore.getSituacoes(),
      this.getAntecipacaoStore.getFontesPagadorasAntecipacao(),
      this.getAntecipacaoStore.getHistoricoAntecipacao(this.filtrosHistorico),
    ])
  }

  @Watch('filtroDataInicio')
  @Watch('filtroDataFim')
  @Watch('filtroStatus')
  @Watch('filtroHospital')
  async onFiltroChange() {
    this.getAntecipacaoStore.setHistoricoPagina(1)
    await this.getAntecipacaoStore.getHistoricoAntecipacao(this.filtrosHistorico)
  }

  mounted() {
    this.carregar()
  }
}
